import { setReferer } from '@/common/utils/referer'
import { beforeEnterNeedAdultCheckPage } from '@/common/utils/common'
import {
  PATH_NAME_PLAYER_BASEBALL_HIGHLIGHT,
  PATH_NAME_PLAYER_BASEBALL_LIVE,
  PATH_NAME_PLAYER_LIVE,
  PATH_NAME_PLAYER_MOVIE,
  PATH_NAME_PLAYER_VOD
} from '@/common/resources/router.const'

export default [
  {
    path: 'player/vod',
    name: PATH_NAME_PLAYER_VOD,
    meta: { section: 'vod' },
    alias: '/player/vod.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "player_vod" */'@/pages/player/vod')
    },
    beforeEnter: (to, from, next) => {
      if (from.name !== 'login' && from.name !== 'profile_list') {
        setReferer(from.fullPath)
      }
      next()
    }
  },
  {
    path: 'player/live',
    name: PATH_NAME_PLAYER_LIVE,
    meta: { section: 'live' },
    alias: '/player/live.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "player_live" */'@/pages/player/live')
    }
  },
  {
    path: 'player/movie',
    name: PATH_NAME_PLAYER_MOVIE,
    meta: { section: 'movie' },
    alias: '/player/movie.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "player_movie" */'@/pages/player/movie')
    },
    beforeEnter: beforeEnterNeedAdultCheckPage
  },
  {
    path: 'player/baseball/live',
    name: PATH_NAME_PLAYER_BASEBALL_LIVE,
    meta: { section: 'baseball_live' },
    alias: '/player/baseball/live.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "player_baseball_live" */'@/pages/player/baseball/baseballLive')
    }
  },
  {
    path: 'player/baseball/highlight',
    name: PATH_NAME_PLAYER_BASEBALL_HIGHLIGHT,
    meta: { section: 'baseball_highlight' },
    alias: '/player/baseball/highlight.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "player_baseball_highlight" */'@/pages/player/baseball/highlight')
    }
  }
  // {
  //   path: '/player/clip',
  //   name: 'player_clip',
  //   meta: { section: 'clip' },
  //   alias: '/player/clip.html',
  //   components: {
  //     bodyContent: () => import(/* webpackChunkName: "player_clip" */'@/pages/player/clip')
  //   }
  // }
]
